import { useTranslation } from 'react-i18next'
import { Link, useRouteError } from 'react-router-dom'
import { useLocale } from '@/lib/useLocale'
import { Button } from '@/components/ui/button'
import { CenteredCard } from '@/components/layouts'

/**
 * Route-level error element — a render error in one lazy page shows this card
 * instead of unmounting the whole app to the top-level ErrorBoundary.
 */
export function RouteError() {
  const { t } = useTranslation()
  const locale = useLocale()
  useRouteError() // touched only to keep react-router's contract explicit
  return (
    <CenteredCard>
      <h1 className="mb-2 font-heading text-xl font-semibold">{t('common.error')}</h1>
      <p className="text-sm text-muted-foreground">{t('error.boundaryDesc')}</p>
      <div className="mt-4 flex gap-2">
        <Button onClick={() => window.location.reload()}>{t('error.boundaryReload')}</Button>
        <Button variant="outline" asChild>
          <Link to={`/${locale}`}>{t('nav.home')}</Link>
        </Button>
      </div>
    </CenteredCard>
  )
}